import { GET_ADDRESSES } from "./maps.constants";

export const getAddresses = (payload, callback) => ({type: GET_ADDRESSES, payload, callback});